import { render, staticRenderFns } from "./MetasCrescimento.vue?vue&type=template&id=6be13fe0&"
import script from "./MetasCrescimento.vue?vue&type=script&lang=js&"
export * from "./MetasCrescimento.vue?vue&type=script&lang=js&"
import style0 from "./MetasCrescimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/MetasCrescimento.vue
// module id = 116
// module chunks = 28